import SuggestedActionIcon from './SuggestedActionIcon.component';

export default SuggestedActionIcon;